/** @jsxRuntime classic */
/** @jsx jsx */
import { Box, Container, Link, Text } from '@bottlebooks/gatsby-theme-base';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout';
import { LinkProvider } from '@bottlebooks/gatsby-theme-event/src/useLink';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ExploreNewReleases from '../../components/ExploreWines/ExploreNewReleases';
import ExploreWinesSwitcher from '../../components/ExploreWines/ExploreWinesSwitcher';

export default function NewReleasesPage({ pageContext, data }) {
  const { bottlebooks } = data;
  const { importers, exporters } = bottlebooks;
  return (
    <LinkProvider value={pageContext.paths}>
      <Layout {...pageContext}>
        <Box sx={{ backgroundColor: 'light', paddingTop: [2, null, 4] }}>
          <Container>
            <ExploreWinesSwitcher>
              <Link to="/products">
                <Text>
                  Or search by vegan, organic, on-trade and 10 other filters….
                </Text>
              </Link>
            </ExploreWinesSwitcher>
            <ExploreNewReleases
              wines={importers.wines.nodes.concat(exporters.wines.nodes)}
              sx={{ paddingY: 3, backgroundColor: 'white' }}
            />
          </Container>
        </Box>
      </Layout>
    </LinkProvider>
  );
}

export const query = graphql`
  query NewReleasesPage($locale: Bottlebooks_ContentLocale!) {
    bottlebooks {
      importers: event(eventId: "6245aca1082cf60f03bcf8a9", locale: $locale) {
        ...NewReleasesPage_Fragment
      }
      exporters: event(eventId: "6245ab1a8ff6ae0f06a16a60", locale: $locale) {
        ...NewReleasesPage_Fragment
      }
    }
  }
  fragment NewReleasesPage_Fragment on Bottlebooks_Event {
    wines: registeredProducts {
      nodes {
        ...ExploreNewReleases
      }
    }
  }
`;
